import { Route, Routes } from "react-router-dom";

import Client from "./pages/client"

const App = () => {
  return (
    <div className="layout">
      <Routes>
        <Route path="/:company/:campaign" element={<Client />} />
      </Routes>
    </div>
  );
}

export default App;
